import { Box, CircularProgress, Modal } from "@mui/material";
import { LoadingModalProps } from "./interface";

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

const LoadingModal = ({ openState }: LoadingModalProps) => {
    return (
        <Modal open={openState}>
            <Box sx={style}>
                <CircularProgress />
            </Box>
        </Modal>
    );
};

export default LoadingModal;
